import { render, staticRenderFns } from "./FileContainer.vue?vue&type=template&id=04142933"
import script from "./FileContainer.vue?vue&type=script&lang=js"
export * from "./FileContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports